import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    loadingWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
    },
    list: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
    },
    // Unstyled button chrome, like the AppToolbar brand button: the row is a real
    // <button>, so focus, Enter and Space come from the platform.
    row: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5),
        width: "100%",
        padding: theme.spacing(0.75, 1),
        border: "none",
        borderRadius: theme.spacing(0.5),
        backgroundColor: "transparent",
        fontFamily: "inherit",
        textAlign: "left",
        cursor: "pointer",
        transition: "opacity 150ms ease-in-out, background-color 150ms ease-in-out",
        "&:hover": {
            backgroundColor: theme.palette.secondary.main,
        },
        "&:focus-visible": {
            outline: `2px solid ${theme.palette.info.main}`,
            outlineOffset: "2px",
        },
    },
    rowActive: {
        opacity: 1,
    },
    rowDimmed: {
        opacity: 0.5,
    },
    rowHeader: {
        display: "flex",
        alignItems: "baseline",
        justifyContent: "space-between",
        gap: theme.spacing(1),
    },
    name: {
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontFamily: "Source Sans 3",
        fontSize: 13,
        fontWeight: 400,
        color: theme.palette.text.primary,
    },
    nameSelected: {
        fontWeight: 700,
    },
    percent: {
        flexShrink: 0,
        fontFamily: "Source Sans 3",
        fontSize: 13,
        fontWeight: 700,
        fontVariantNumeric: "tabular-nums",
        color: theme.palette.success.main,
    },
    track: {
        display: "block",
        width: "100%",
        height: theme.spacing(1.25),
        overflow: "hidden",
        borderRadius: 50,
        backgroundColor: theme.palette.disabled.track,
    },
    fill: {
        display: "block",
        height: "100%",
        borderRadius: 50,
        backgroundColor: theme.palette.success.main,
        transition: "width 300ms ease-in-out",
    },
    optionWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        marginTop: theme.spacing(2),
    },
}));
